import $axios from "../../api";

const state = () => ({
  isLoading: false,
  isLoadingBrand: false,
  isLoadingWarehouse: false,
  isErrors: "",
  categoryList: [],
  subCategoryList: [],
  subUnitCategoryList: [],
  brandList: [],
  listBrand: [],
  tagProductList: [],
  productList: [],
  skuSapList: [],
  paymentList: [],
  memberList: [],
  areaList: [],
  salesList: [],
  memberUnionList: [],
  salesUnionList: [],
  expeditionList: [],
  priceGroupList: [],
  nameAliasList: [],
  routeGroupList: [],
  modulesList: [],
  modulesParentList: [],
  modulesSectionList: [],
  modulesTypeList: [],
  iconList: [],
  promoList: [],
  promosugestList: [],
  userGroupList: [],
  userList: [],
  emailTypeList: [],
  storeList: [],
  warehouseList: [],
  warehouseAreaList: [],
  warehouseTypeList: [],
  brandUnderList: [],
  departmentList: [],
  divisionList: [],
  productLabelList: [],
  levelList: [],
  companyList: [],
  ocrcList: [],
  ocrpList: [],
  diseasesSequenceList: [],
  badgeList: [],
  listBinNumber: [],
  freeProductList: [],
  materialStorageList: [],
  couponList: [],
  stockerList: [],
  adminList: [],
  posPromoTypeList: [],
  employeeList: [],
  loadCategory: false,
  loadSubCategory: false,
  loadSubUnitCategory: false,
  loadingProduct: false,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOAD_CATEGORY(state, payload) {
    state.loadCategory = payload;
  },
  SET_LOAD_SUB_CATEGORY(state, payload) {
    state.loadSubCategory = payload;
  },
  SET_LOAD_SUB_UNIT_CATEGORY(state, payload) {
    state.loadSubUnitCategory = payload;
  },
  SET_LOADING_BRAND(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_PRODUCT(state, payload) {
    state.loadingProduct = payload;
  },
  SET_LOADING_WAREHOUSE(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  ASSIGN_CATEGORY_LIST(state, payload) {
    state.categoryList = payload;
  },
  ASSIGN_SUB_CATEGORY_LIST(state, payload) {
    state.subCategoryList = payload;
  },
  ASSIGN_SUB_UNIT_CATEGORY_LIST(state, payload) {
    state.subUnitCategoryList = payload;
  },
  ASSIGN_BRAND_LIST(state, payload) {
    state.brandList = payload;
  },
  ASSIGN_TAG_PRODUCT_LIST(state, payload) {
    state.tagProductList = payload;
  },
  ASSIGN_PRODUCT_LIST(state, payload) {
    state.productList = payload;
  },
  ASSIGN_SKU_SAP_LIST(state, payload) {
    state.skuSapList = payload;
  },
  ASSIGN_PAYMENT_LIST(state, payload) {
    state.paymentList = payload;
  },
  ASSIGN_MEMBER_LIST(state, payload) {
    state.memberList = payload;
  },
  ASSIGN_AREA_LIST(state, payload) {
    state.areaList = payload;
  },
  ASSIGN_SALES_LIST(state, payload) {
    state.salesList = payload;
  },
  ASSIGN_SALES_UNION_LIST(state, payload) {
    state.salesUnionList = payload;
  },
  ASSIGN_MEMBER_UNION_LIST(state, payload) {
    state.memberUnionList = payload;
  },
  ASSIGN_EXPEDITION_LIST(state, payload) {
    state.expeditionList = payload;
  },
  ASSIGN_GROUP_LIST(state, payload) {
    state.priceGroupList = payload;
  },
  ASSIGN_NAME_ALIAS(state, payload) {
    state.nameAliasList = payload;
  },
  ASSIGN_MODULES_LIST(state, payload) {
    state.modulesList = payload;
  },
  ASSIGN_MODULES_PARENT_LIST(state, payload) {
    state.modulesParentList = payload;
  },
  ASSIGN_MODULES_SECTION_LIST(state, payload) {
    state.modulesSectionList = payload;
  },
  ASSIGN_MODULES_TYPE_LIST(state, payload) {
    state.modulesTypeList = payload;
  },
  ASSIGN_ICON_LIST(state, payload) {
    state.iconList = payload;
  },
  ASSIGN_PROMO_LIST(state, payload) {
    state.promoList = payload;
  },
  ASSIGN_PROMOSUGEST_LIST(state, payload) {
    state.promosugestList = payload;
  },
  ASSIGN_LIST_BRAND(state, payload) {
    state.listBrand = payload;
  },
  ASSIGN_USER_GROUP_LIST(state, payload) {
    state.userGroupList = payload;
  },
  ASSIGN_USER_LIST(state, payload) {
    state.userList = payload;
  },
  ASSIGN_EMAIL_TYPE_LIST(state, payload) {
    state.emailTypeList = payload;
  },
  ASSIGN_STORE_LIST(state, payload) {
    state.storeList = payload;
  },
  ASSIGN_WAREHOUSE_LIST(state, payload) {
    state.warehouseList = payload;
  },
  ASSIGN_WAREHOUSE_AREA_LIST(state, payload) {
    state.warehouseAreaList = payload;
  },
  ASSIGN_WAREHOUSE_TYPE_LIST(state, payload) {
    state.warehouseTypeList = payload;
  },
  ASSIGN_BRAND_UNDER(state, payload) {
    state.brandUnderList = payload;
  },
  ASSIGN_TABLE_UNIONWEB(state, payload) {
    state.tableUnionWebList = payload;
  },
  ASSIGN_DEPARTMENT(state, payload) {
    state.departmentList = payload;
  },
  ASSIGN_DIVISION(state, payload) {
    state.divisionList = payload;
  },
  ASSIGN_LABEL_PRODUCT_LIST(state, payload) {
    state.productLabelList = payload;
  },
  ASSIGN_LEVEL(state, payload) {
    state.levelList = payload;
  },
  ASSIGN_COMPANY(state, payload) {
    state.companyList = payload;
  },
  ASSIGN_OCRP(state, payload) {
    state.ocrpList = payload;
  },
  ASSIGN_OCRC(state, payload) {
    state.ocrcList = payload;
  },
  ASSIGN_DISEASES_SEQUENCE(state, payload) {
    state.diseasesSequenceList = payload;
  },
  ASSIGN_BADGE(state, payload) {
    state.badgeList = payload;
  },
  ASSIGN_LIST_BIN_NUMBER(state, payload) {
    state.listBinNumber = payload
  },
  ASSIGN_FREE_PRODUCT_LIST(state, payload) {
    state.freeProductList = payload;
  },
  ASSIGN_LOAD_MATERIAL_STORAGE(state, payload) {
    state.materialStorageList = payload;
  },
  ASSIGN_COUPON_LIST(state, payload) {
    state.couponList = payload;
  },
  ASSIGN_ROUTE_GROUP_LIST(state, payload) {
    state.routeGroupList = payload;
  },
  ASSIGN_STOCKER_LIST(state, payload) {
    state.stockerList = payload;
  },
  ASSIGN_ADMIN_SO_LIST(state, payload) {
    state.adminList = payload;
  },
  ASSIGN_POS_PROMO_TYPE_LIST(state, payload) {
    state.posPromoTypeList = payload;
  },
  ASSIGN_EMPLOYEE_LIST(state, payload) {
    state.employeeList = payload;
  }
};

const actions = {
  selectIcons({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/icon?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_ICON_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectCategory({ commit, state, rootState, dispatch }, payload) {
    // commit("SET_LOADING", true);
    commit("SET_LOAD_CATEGORY", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/category${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_CATEGORY_LIST", res.data.data);
          commit("SET_LOAD_CATEGORY", false);
          // commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectSubCategory({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_LOAD_SUB_CATEGORY", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/subcategory${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_SUB_CATEGORY_LIST", res.data.subcategory);
          commit("SET_LOADING", false);
          commit("SET_LOAD_SUB_CATEGORY", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectSubUnitCategory({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_LOAD_SUB_UNIT_CATEGORY", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/unit${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_SUB_UNIT_CATEGORY_LIST", res.data.data);
          commit("SET_LOADING", false);
          commit("SET_LOAD_SUB_UNIT_CATEGORY", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectBrand({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_BRAND", true);
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      if (payload.find) {
        params.append('find', payload.find);
      }
      if (payload.under) {
        params.append('under', payload.under);
      }

      $axios
        .get(`select/brand?${params.toString()}`)
        .then((res) => {
          commit("ASSIGN_BRAND_LIST", res.data.data);
          commit("SET_LOADING_BRAND", false);
        })
        .catch((error) => {
          commit("SET_LOADING_BRAND", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectTagProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/tag?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_TAG_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/product?product_name=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
          resolve()
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error)
        });
    });
  },
  selectProductLive({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/product-live?product_name=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
          resolve()
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error)
        });
    });
  },
  selectProductV2({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_PRODUCT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/product-v2`, {
          params: {
            brand_id: payload?.brand_id,
            filter_brand_type: payload?.filter_brand_type,
            category_id: payload?.category_id,
            filter_category_type: payload?.filter_category_type,
            variants: payload?.variants,
            filter_variants_type: payload?.filter_variants_type,
            name: payload?.name,
            filter_name_type: payload?.filter_name_type,
          }
        })
        .then((res) => {
          commit("ASSIGN_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING_PRODUCT", false);
          resolve()
        })
        .catch((error) => {
          reject()
          commit("SET_LOADING_PRODUCT", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectProductWeb({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/product-web?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectProductWebId({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/product-web-id?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectFreeProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/product-web?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_FREE_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectSKUSap({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/skusap?searchname=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_SKU_SAP_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectSkuUnion({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/sku?searchname=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_SKU_SAP_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectPayment({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/payment${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PAYMENT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectMember({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/member?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_MEMBER_LIST", res.data.data);
          commit("SET_LOADING", false);
          resolve();
        })
        .catch((error) => {
          reject(error);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectMemberWebsiteApp({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/member-website-app?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_MEMBER_LIST", res.data.data);
          commit("SET_LOADING", false);
          resolve();
        })
        .catch((error) => {
          reject(error);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectArea({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/cityprovince?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_AREA_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectSales({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/sales?name=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_SALES_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectSalesUnion({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/sales-union?sales_code=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_SALES_UNION_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectMemberUnion({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/member-union?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_MEMBER_UNION_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectExpedition({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/shipping${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_EXPEDITION_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectPriceGroup({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/pricegroup${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_GROUP_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectNameAlias({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/namealias?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_NAME_ALIAS", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectRouteGroup({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/routegroup?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_ROUTE_GROUP_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectname({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/module?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_MODULES_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectParentModule({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/moduleparent?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_MODULES_PARENT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectSectionModule({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/modulesection?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_MODULES_SECTION_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectTypeModule({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/moduletype?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_MODULES_TYPE_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectActivePromo({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`select/activepromo`, payload)
        .then((res) => {
          commit("ASSIGN_PROMO_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectPromoSugest({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/promosugest`, payload)
        .then((res) => {
          commit("ASSIGN_PROMOSUGEST_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectListBrand({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/listbrand`, {
          params: payload
        })
        .then((res) => {
          commit("ASSIGN_LIST_BRAND", res.data.data);
          commit("SET_LOADING", false);
          resolve()
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error)
        });
    });
  },
  selectUserGroup({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/pricegroup?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_USER_GROUP_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectUser({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/user?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_USER_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectEmailType({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/email-type?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_EMAIL_TYPE_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectStore({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`dashboardsync/offline-store/select-store?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_STORE_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectStoreWeb({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/store?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_STORE_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectWarehouse({ commit, state, rootState, dispatch }, payload) {
    console.log(payload);
    commit("SET_LOADING_WAREHOUSE", true);
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      if (payload.find) {
        params.append('find', payload.find);
      }
      if (payload.area) {
        params.append('area', payload.area);
      }
      if (payload.type) {
        params.append('type', payload.type);
      }
      $axios
        .get(`select/warehouse?${params.toString()}`)
        .then((res) => {
          commit("ASSIGN_WAREHOUSE_LIST", res.data.data);
          commit("SET_LOADING_WAREHOUSE", false);
        })
        .catch((error) => {
          commit("SET_LOADING_WAREHOUSE", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectWarehouseArea({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/warehouse-area?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_WAREHOUSE_AREA_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectWarehouseType({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/warehouse-type?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_WAREHOUSE_TYPE_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectBrandUnder({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/brand-under?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_BRAND_UNDER", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectTableUnionWeb({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/table-unionweb?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_TABLE_UNIONWEB", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectDepartment({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/department?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_DEPARTMENT", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectDivision({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/division?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_DIVISION", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectLabelProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`website/select/product?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_LABEL_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectLevel({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/level?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_LEVEL", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectCompany({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/company?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_COMPANY", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectOcrpPaymentType({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/ocrp-payment-type?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_OCRP", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectOcrcPaymentChannel({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/ocrc-payment-channel?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_OCRC", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },

  selectProductTiktok({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/product-free-item?product_name=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },

  selectDiseasesSequence({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/diseases`)
        .then((res) => {
          commit("ASSIGN_DISEASES_SEQUENCE", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },

  selectBadge({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios.get(`/website/promotion/select/badge?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_BADGE", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },

  selectBinNumber({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios.get(`select/bin-number`)
        .then((res) => {
          commit("ASSIGN_LIST_BIN_NUMBER", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },

  selectMaterialStorage({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/material-storage?type=` + payload.type)
        .then((response) => {
          commit("SET_LOADING", false);
          commit("ASSIGN_LOAD_MATERIAL_STORAGE", response.data.data);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject();
        });
    });
  },

  selectCoupon({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/coupon`, {
          params:
          {
            find: payload ? payload : undefined
          }
        })
        .then((response) => {
          commit("ASSIGN_COUPON_LIST", response.data.data);
          commit("SET_LOADING", false);
          resolve(response.data.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },

  selectArticleCategory({ commit, state, rootState, dispatch }, payload) {
    // commit("SET_LOADING", true);
    commit("SET_LOAD_CATEGORY", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/article-category${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_CATEGORY_LIST", res.data.data);
          commit("SET_LOAD_CATEGORY", false);
          // commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectStocker({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/stocker?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_STOCKER_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectAdminSO({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/admin-so?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_ADMIN_SO_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectWarehouseSO({ commit, dispatch }, payload = {}) {
    commit("SET_LOADING_WAREHOUSE", true);

    const params = new URLSearchParams();

    if (payload.find) {
      params.append("find", payload.find);
    }

    return $axios
      .get(`select/warehouse-so?${params.toString()}`)
      .then((res) => {
        commit("ASSIGN_WAREHOUSE_LIST", res.data.data);
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
      })
      .finally(() => {
        commit("SET_LOADING_WAREHOUSE", false);
      });
  },
  selectPosPromoType({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/pos-promotion-type?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_POS_PROMO_TYPE_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  selectEmployee({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`select/employee?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_EMPLOYEE_LIST", res.data.data);
          resolve();
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  }

};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
